import React from 'react';
import { useTranslation } from 'react-i18next';

import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';

export const Loader: React.FC<{ isLoading?: boolean; showDefaultText?: boolean } & CircularProgressProps> = ({
  isLoading = true,
  showDefaultText = false,
  ...rest
}) => {
  const { t } = useTranslation(['candidate_recruiter']);
  if (!isLoading) return null;

  const Text = (
    <div>
      <h4 style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {t('GENERAL.GENERIC.checkingDocuments')}
      </h4>
      <p>{t('GENERAL.GENERIC.dontCloseApp')}</p>
    </div>
  );

  return (
    <div className="loader-centred tag-ds">
      {showDefaultText ? (
        <>
          <CircularProgress {...rest} color="info" size={100} />
          {Text}
        </>
      ) : (
        <CircularProgress {...rest} />
      )}
    </div>
  );
};
